import apiV2Service from '../api/api-v2.service';
import { BrandGuidelines, Persona } from './brandGuidelines.types';

const BASE_PATH = 'Clients';

async function getBrandGuidelines(): Promise<BrandGuidelines> {
  const {data} = await apiV2Service.executeGetRequest<BrandGuidelines>(
    `${BASE_PATH}/BrandGuidelines`,
  );

  return data;
}

async function updateBrandGuidelines(
  brandGuidelines: BrandGuidelines,
): Promise<void> {
  const {data} = await apiV2Service.executePutRequest<void>(
    `${BASE_PATH}/BrandGuidelines`,
    {},
    {...brandGuidelines},
  );

  return data;
}

async function getPersonas(): Promise<Persona[]> {
  const {data} = await apiV2Service.executeGetRequest<Persona[]>(`${BASE_PATH}/Personas`);

  return data;
}

async function addPersona(persona: Omit<Persona, 'id'>): Promise<void> {
  const {data} = await apiV2Service.executePostRequest<void>(
    `${BASE_PATH}/Personas`,
    {},
    {...persona},
  );

  return data;
}

async function updatePersona(persona: Persona): Promise<void> {
  const {data} = await apiV2Service.executePutRequest<void>(
    `${BASE_PATH}/Personas`,
    {},
    {...persona},
  );

  return data;
}

async function deletePersona(personaId: number): Promise<void> {
  const {data} = await apiV2Service.executeDeleteRequest<void>(
    `${BASE_PATH}/Personas/${personaId}`,
  );

  return data;
}

const brandGuidelinesApi = {
  getBrandGuidelines,
  updateBrandGuidelines,
  getPersonas,
  addPersona,
  updatePersona,
  deletePersona,
};

export default brandGuidelinesApi; 